import { Routes } from '@angular/router';
import { StockComponent } from './pages/stock/stock.component';
import { StockUnitSearchComponent } from './pages/stock/stock-unit-search/stock-unit-search.component';
import { NatisDocumentsComponent } from './pages/natis-documents/natis-documents.component';
import { UnitOverviewComponent } from './pages/stock/unit-overview/unit-overview.component';
import { DemoStockComponent } from './pages/demo-stock/demo-stock.component';
import { BuildToOrderComponent } from './pages/build-to-order/build-to-order.component';
import { ReplenishmentStockComponent } from './pages/replenishment-stock/replenishment-stock.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { ReplenishOpenRequestsComponent } from './pages/replenishment-open-requests/replenish-open-requests.component';
import { DemoOpenRequestsComponent } from './pages/demo-open-requests/demo-open-requests.component';
import { ShowroomCapacityComponent } from './pages/showroom-capacity/showroom-capacity.component';
import { LandingComponent } from './pages/landing/landing.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import {LogoutComponent} from "./pages/logout/logout.component";

export const routes: Routes = [
    { path: 'tabs', component: TabsComponent, canActivate: [AuthGuard] },
    { path: 'stock', component: StockComponent, canActivate: [AuthGuard] },
    { path: 'stock-unit-search', component: StockUnitSearchComponent, canActivate: [AuthGuard] },
    { path: 'natis-documents', component: NatisDocumentsComponent, canActivate: [AuthGuard] },
    { path: 'unit-overview', component: UnitOverviewComponent, canActivate: [AuthGuard] },
    { path: 'replenishment-stock', component: ReplenishmentStockComponent, canActivate: [AuthGuard] },
    { path: 'replenishment-open-requests', component: ReplenishOpenRequestsComponent, canActivate: [AuthGuard] },
    { path: '', component: LandingComponent, canActivate: [AuthGuard] },
    { path: 'landing', component: LandingComponent, canActivate: [AuthGuard] },
    { path: 'demo-stock', component: DemoStockComponent, canActivate: [AuthGuard] },
    { path: 'demo-open-requests', component: DemoOpenRequestsComponent, canActivate: [AuthGuard] },
    { path: 'build-to-order', component: BuildToOrderComponent, canActivate: [AuthGuard] },
    { path: 'showroom-capacity', component: ShowroomCapacityComponent, canActivate: [AuthGuard] },
    { path: 'logout', component: LogoutComponent },
    { path: '**', redirectTo: '' },
];
